import { render, staticRenderFns } from "./Advanced.vue?vue&type=template&id=572a36cc&scoped=true"
import script from "./Advanced.vue?vue&type=script&lang=js"
export * from "./Advanced.vue?vue&type=script&lang=js"
import style0 from "./Advanced.vue?vue&type=style&index=0&id=572a36cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572a36cc",
  null
  
)

export default component.exports